import React from 'react';
export var Bed = function Bed() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 9H13V15H21V11C21 9.9 20.1 9 19 9Z",
    fill: "#AAA7FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 12C7.55228 12 8 11.5523 8 11C8 10.4477 7.55228 10 7 10C6.44772 10 6 10.4477 6 11C6 11.5523 6.44772 12 7 12Z",
    fill: "#AAA7FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 11C4 12.66 5.34 14 7 14C8.66 14 10 12.66 10 11C10 9.34 8.66 8 7 8C5.34 8 4 9.34 4 11ZM8 11C8 11.55 7.55 12 7 12C6.45 12 6 11.55 6 11C6 10.45 6.45 10 7 10C7.55 10 8 10.45 8 11ZM19 7H11V15H3V5H1V20H3V17H21V20H23V11C23 8.79 21.21 7 19 7ZM21 15H13V9H19C20.1 9 21 9.9 21 11V15Z",
    fill: "#2D2D2D"
  }));
};
export var Bath = function Bath() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 13H2V17H18V13Z",
    fill: "#AAA7FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 7C6.10457 7 7 6.10457 7 5C7 3.89543 6.10457 3 5 3C3.89543 3 3 3.89543 3 5C3 6.10457 3.89543 7 5 7Z",
    fill: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 11V2.83C18 1.27 16.73 0 15.17 0C14.42 0 13.7 0.3 13.17 0.83L11.92 2.08C11.76 2.03 11.59 2 11.41 2C11.01 2 10.64 2.12 10.33 2.32L13.09 5.08C13.29 4.77 13.41 4.4 13.41 4C13.41 3.82 13.38 3.66 13.34 3.49L14.59 2.24C14.74 2.09 14.95 2 15.17 2C15.63 2 16 2.37 16 2.83V11H9.15C8.85 10.79 8.58 10.55 8.33 10.28L6.93 8.73C6.74 8.52 6.5 8.35 6.24 8.23C5.93 8.08 5.59 8 5.24 8C4 8.01 3 9.01 3 10.25V11H0V17C0 18.1 0.9 19 2 19C2 19.55 2.45 20 3 20H17C17.55 20 18 19.55 18 19C19.1 19 20 18.1 20 17V11H18ZM18 17H2V13H18V17Z",
    fill: "#2D2D2D"
  }));
};
export var Car = function Car() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 17H19V12H5V17ZM16.5 13C17.33 13 18 13.67 18 14.5C18 15.33 17.33 16 16.5 16C15.67 16 15 15.33 15 14.5C15 13.67 15.67 13 16.5 13ZM7.5 13C8.33 13 9 13.67 9 14.5C9 15.33 8.33 16 7.5 16C6.67 16 6 15.33 6 14.5C6 13.67 6.67 13 7.5 13Z",
    fill: "#AAA7FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.92 6.01C18.72 5.42 18.16 5 17.5 5H6.5C5.84 5 5.29 5.42 5.08 6.01L3 12V20C3 20.55 3.45 21 4 21H5C5.55 21 6 20.55 6 20V19H18V20C18 20.55 18.45 21 19 21H20C20.55 21 21 20.55 21 20V12L18.92 6.01ZM6.85 7H17.14L18.22 10.11H5.77L6.85 7ZM19 17H5V12H19V17Z",
    fill: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 16C8.32843 16 9 15.3284 9 14.5C9 13.6716 8.32843 13 7.5 13C6.67157 13 6 13.6716 6 14.5C6 15.3284 6.67157 16 7.5 16Z",
    fill: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 16C17.3284 16 18 15.3284 18 14.5C18 13.6716 17.3284 13 16.5 13C15.6716 13 15 13.6716 15 14.5C15 15.3284 15.6716 16 16.5 16Z",
    fill: "#2D2D2D"
  }));
};
export var Measure = function Measure() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 2H4C2.9 2 2 2.9 2 4V16C2 17.1 2.9 18 4 18H16C17.1 18 18 17.1 18 16V4C18 2.9 17.1 2 16 2ZM16 16H4V4H16V16Z",
    fill: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0.5",
    y: "0.5",
    width: "5",
    height: "5",
    rx: "0.5",
    fill: "#AAA7FC",
    stroke: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "14.5",
    y: "0.5",
    width: "5",
    height: "5",
    rx: "0.5",
    fill: "#AAA7FC",
    stroke: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0.5",
    y: "14.5",
    width: "5",
    height: "5",
    rx: "0.5",
    fill: "#AAA7FC",
    stroke: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "14.5",
    y: "14.5",
    width: "5",
    height: "5",
    rx: "0.5",
    fill: "#AAA7FC",
    stroke: "#2D2D2D"
  }));
};
export var Elevator = function Elevator() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 7.625H18.5V12.5H6.5V7.625ZM12.875 11.125H18.5V19.75H12.875V11.125ZM12.625 11.125H12.75V19.75H12.625V11.125ZM6.5 11.125H12.5V19.75H6.5V11.125Z",
    fill: "#AAA7FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 5.625H6.5C5.4 5.625 4.5 6.525 4.5 7.625V19.75C4.5 20.85 5.4 21.75 6.5 21.75H18.5C19.6 21.75 20.5 20.85 20.5 19.75V7.625C20.5 6.525 19.6 5.625 18.5 5.625ZM11.3333 19.75H6.5V7.625H11.3333V19.75ZM12.375 19.75H12.625V7.625H12.375V19.75ZM18.5 19.75H13.7333V7.625H18.5V19.75ZM18.5 7.25H6.5V7.625H18.5V7.25Z",
    fill: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91723 2.39061C9.06381 2.15365 9.40847 2.15365 9.55506 2.39061L10.5059 3.92778C10.6605 4.17761 10.4808 4.50006 10.187 4.50006H8.28526C7.9915 4.50006 7.81181 4.17761 7.96635 3.92778L8.91723 2.39061Z",
    fill: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.178 4.35963C16.0314 4.59659 15.6867 4.59659 15.5402 4.35963L14.5893 2.82246C14.4347 2.57263 14.6144 2.25018 14.9082 2.25018L16.81 2.25018C17.1037 2.25018 17.2834 2.57263 17.1289 2.82246L16.178 4.35963Z",
    fill: "#2D2D2D"
  }));
};